import { Box, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import { ToggleButton } from '@material-ui/lab';
import { green, purple } from 'globals/colors';

export const Caption = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.grey[300],
    display: 'block',
    margin: spacing(1.5, 0),
  },
}))(FsCaption);

export const TabsContainerBox = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: spacing(0, -0.6),
    marginTop: spacing(1),
  },
}))(Box);

export const Tab = withStyles(({ spacing }) => ({
  root: {
    flexGrow: 1,
    flexBasis: 0,
    justifyContent: 'flex-start',
    background: purple.V5,
    margin: spacing(0, 0.6, 1.2),
    padding: spacing(1.5, 2),
    border: 0,
    borderRadius: spacing(1),
    fontWeight: 400,
    '&:hover': {
      background: purple.V4,
    },
    '&:hover .tabIcon:after': {
      transform: 'translate(-50%, -50%) scale(0.5)',
    },
  },
  selected: {
    background: `${purple.V3} !important`,
    '& .tabIcon:after': {
      transform: 'translate(-50%, -50%) scale(1) !important',
    },
  },
}))(ToggleButton);

export const TabIcon = withStyles(({ spacing, palette }) => ({
  root: {
    display: 'block',
    width: spacing(3),
    height: spacing(3),
    border: `1px solid ${purple.V3}`,
    borderRadius: '50%',
    marginRight: spacing(1),
    background: palette.common.white,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: spacing(2),
      height: spacing(2),
      borderRadius: '50%',
      background: green.MAIN,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(0)',
      transition: `transform .3s ease-in-out`,
    },
  },
}))(Box);
